const WalletKind = {
  metamask: "metamask",
  coinbase: "coinbase",
  walletconnect: "walletconnect",
};

export default WalletKind;
